import { getFASvgInfo } from "./faUtils";

/**
 * Renders a FontAwesome icon as an svg given the slug (i.e. fa-user)
 */
export function FAIcon({ slug }: { slug: string }) {
  const name = slug.replace("fa-", "");
  const faIcon = getFASvgInfo(name);

  if (!faIcon) return null;

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="20"
      viewBox={faIcon.viewBox}
      width="20"
    >
      <path d={faIcon.path} fill="currentColor"></path>
    </svg>
  );
}
